import React from 'react';
import { ArrowRight } from 'lucide-react';

const STAGES = [
  ['01', 'Understand', 'Business model • Cash flows • Leverage • Security • Capital requirement', 'Understand the business, funding objective, financial position and constraints before considering a financing structure.'],
  ['02', 'Structure', 'Instrument • Amount • Tenure • Repayment • Security • Covenants', 'Develop a financing structure aligned with the company\u2019s cash flows, objectives and repayment capacity.'],
  ['03', 'Compare', 'Lender appetite • Pricing • Terms • Flexibility • Execution certainty', 'Evaluate appropriate banks, NBFCs, financial institutions and capital providers across commercial and structural parameters.'],
  ['04', 'Execute', 'Negotiation • Documentation • Coordination • Sanction • Financial closure', 'Coordinate the transaction from lender engagement and commercial negotiation through documentation, sanction and closure.']
];

export const OurApproach = () => {
  return (
    <section className="py-24 bg-slate-50" data-testid="our-approach">
      <div className="container mx-auto px-4">
        <div className="text-center max-w-3xl mx-auto mb-16">
          <h2 className="text-3xl lg:text-4xl font-bold text-slate-900 mb-4 uppercase tracking-wide">
            Our <span className="text-emerald-600">Approach</span>
          </h2>
          <p className="text-lg text-slate-600">How We Think About Capital</p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6 max-w-7xl mx-auto">
          {STAGES.map(([num, title, desc], idx) => (
            <div key={num} className="relative bg-white rounded-xl border-2 border-slate-200 hover:border-emerald-500 hover:shadow-xl transition-all duration-300 p-8" data-testid={`approach-${title.toLowerCase()}`}>
              <div className="flex items-center justify-between mb-5">
                <span className="text-3xl font-bold text-emerald-600">{num}</span>
                {idx < STAGES.length - 1 && (
                  <ArrowRight className="hidden lg:block w-5 h-5 text-slate-300" />
                )}
              </div>
              <h3 className="text-xl font-bold text-slate-900 mb-3">{title}</h3>
              <p className="text-sm text-slate-600 leading-relaxed">{desc}</p>
            </div>
          ))}
        </div>

        <div className="mt-10 flex items-center justify-center gap-3 text-sm font-semibold text-slate-500 flex-wrap">
          <span className="text-emerald-700">Understand</span>
          <ArrowRight className="w-4 h-4 text-emerald-500" />
          <span className="text-emerald-700">Structure</span>
          <ArrowRight className="w-4 h-4 text-emerald-500" />
          <span className="text-emerald-700">Compare</span>
          <ArrowRight className="w-4 h-4 text-emerald-500" />
          <span className="text-emerald-700">Execute</span>
        </div>
      </div>
    </section>
  );
};
